import { dateFormatServer } from '@alluradirect/react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import { SelectedDateRange, getStayRestrictions } from 'components/views/pages/Checkout/CheckoutDateRangePicker/useDateRangePicker';
import { UnavailableDates } from 'components/views/pages/Checkout/hooks/usePropertyUnavailableDates';
import { Box } from '@mui/material';
import { CalendarDate } from 'components/views/forms/rates/RateSchedule/types';

interface Props {
  day: Date;
  modifiers: any;
  selectedDateRange: SelectedDateRange;
  minNights: UnavailableDates['MIN_NIGHTS_DATES'];
  ratesData?: { [date: string]: [rate: string] };
  calendarDates?: CalendarDate[];
  datesMap?: Map<string, CalendarDate>;
}

const RateDisplay = styled.div`
  font-size: 0.7rem;
  margin-top: -2px;
  line-height: 1;  
  font-weight: 400;
`;

export const DateRangePickerDay = ({ day, modifiers, selectedDateRange, minNights, ratesData, calendarDates, datesMap }: Props) => {
  const dateStr = dateFormatServer(day);
  const rateDisplay = ratesData?.[dateStr] ?? "-";

  if (modifiers.minNight && selectedDateRange.from) {
    let nightsText = '';

    if (calendarDates && datesMap) {
      const { minNightsRequired } = getStayRestrictions(selectedDateRange.from, day, datesMap);
      nightsText = `${minNightsRequired}-`;
    } else if (minNights) {
      const strDay = dateFormatServer(selectedDateRange.from);
      const minNightDate = minNights.find(date => {
        const key = Object.keys(date)[0];
        return key === strDay;
      });
      nightsText = minNightDate ? `${Object.values(minNightDate as any)[0]}-` : '';
    }

    return (
      <Tooltip title={`${nightsText}night minimum`} enterTouchDelay={0} arrow>
        <Box>
          <div>{day.getDate()}</div>
          <RateDisplay>{rateDisplay}</RateDisplay>
        </Box>
      </Tooltip>
    );
  }

  return <>
    <div>{day.getDate()}</div>
    <RateDisplay>{rateDisplay}</RateDisplay>
  </>;
};
